import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { serializeClasses } from 'utilities/css';

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.accentGray03};
  &.active {
    fill: ${({ theme }) => theme.colors.accentGray04};
  }
`;

export const GridIcon = ({ className, active, ...rest }) => {
  const pathClass = serializeClasses([active && 'active']);
  return (
    <svg
      {...rest}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g fill="none" fillRule="evenodd">
        <g
          transform="translate(-1273.000000, -211.000000) translate(1267.000000, 205.000000)"
        >
          <g
            transform="translate(6.000000, 6.000000)"
          >
            <Path
              className={pathClass}
              fillRule="nonzero"
              d="M18.5 20h-6c-.828 0-1.5-.672-1.5-1.5v-6c0-.828.672-1.5 1.5-1.5h6c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5zm0-11h-6c-.828 0-1.5-.672-1.5-1.5v-6c0-.828.672-1.5 1.5-1.5h6c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5zm-17 2h6c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5h-6C.672 20 0 19.328 0 18.5v-6c0-.828.672-1.5 1.5-1.5zM0 1.5C0 .672.672 0 1.5 0h6C8.328 0 9 .672 9 1.5v6C9 8.328 8.328 9 7.5 9h-6C.672 9 0 8.328 0 7.5v-6z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

GridIcon.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool
};

GridIcon.defaultProps = {
  className: undefined,
  active: false
};
